import { DatiFirmaVO } from "@app/shared/vo/dati-firmaVO";
import { DatiPersonaliVO } from "./dati-personaliVO";
import { TipologiaDocumentoVO } from "./tipologia-documentoVO";
import { TipoSupportoDocumentoEnum } from "../enum/tipo-supporto-documento-enum";
import { TipoDocumentoDigitaleEnum } from "../enum/tipo-documento-digitale.enum";
import { AutorizzazioneVO } from "./autorizzazioneVO";
import { AutoreVO } from "./autoreVO";
import { CampoSpecificoFascicoloVO } from "./campo-specifico-fascicoloVO";
import { DownloadStatusVO } from "./download-statusVO";
import { DatiVersionamentoDocumentoDTO } from "../dto/dati-versionamento-documentoDTO";
import { DatiVersionamentoDocumentoVO } from "./dati-versionamento-documentoVO";
import { LinguaVO } from "./linguaVO";

export class DocumentoVO {
  tipologiaDocumento: TipologiaDocumentoVO = new TipologiaDocumentoVO();
  nome: string;
  descrizione: string;
  hash: string = "";
  primario: boolean = false;
  pubblicabile: Boolean;
  contieneDatiPersonali: Boolean;
  idAllegatoPadre: string;
  codice: string;
  datiFirma: DatiFirmaVO;
  preview: boolean;
  verificaFirma: boolean;
  codiceTipologia: string;
  dataManuale: string;
  dataInserimento: string;
  dataUltimaModifica: string;
  idRepository: string;
  autore: AutoreVO;
  firmatario: AutoreVO[];
  tipoDocumentoDigitale: TipoDocumentoDigitaleEnum;
  cartaceo: boolean;
  tipoSupportoOriginale: TipoSupportoDocumentoEnum;
  datiPersonali: DatiPersonaliVO = new DatiPersonaliVO();
  collocazioneFisica: string;
  campiSpecifici: CampoSpecificoFascicoloVO[];
  riservato: boolean;
  esisteRichiestaFirma: boolean;
  statoRichiestaFirma: string;
  motivoFirma: string;
  copiaConforme: boolean;
  datiVersionamento: DatiVersionamentoDocumentoVO;
  info: DownloadStatusVO = new DownloadStatusVO();
  dimensioni: number;
  lingue: LinguaVO[];
}
